/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { useTheme } from '@coursera/cds-core';

type Props = {
  width?: string;
  height?: string;
  cssOverride?: Interpolation<Theme>;
};

const shimmer = keyframes`
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
`;

const styles = {
  container: (_: Theme, widthOverride?: string, heightOverride?: string) => css`
    position: relative;
    display: block;
    width: ${widthOverride || '100%'};
    height: ${heightOverride || '100%'};
    animation: ${shimmer} 2.2s infinite linear;
    background: var(--cds-color-grey-50);
    background: linear-gradient(
      to right,
      var(--cds-color-grey-25) 8%,
      var(--cds-color-grey-50) 18%,
      var(--cds-color-grey-25) 33%
    );
    background-size: 1200px 100%;
  `,
};

const LoadingSkeleton: React.FC<Props> = ({ width, height, cssOverride }) => {
  const theme = useTheme();
  return <div css={[styles.container(theme, width, height), cssOverride]} data-testid="lazy-load" />;
};

export default LoadingSkeleton;
